import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map} from 'rxjs/operators';
// import { MapsAPILoader, } from '@agm/core';
import * as globalConstant from './../global_constant';
import { isPlatformBrowser } from '@angular/common';
import { Loader } from '@googlemaps/js-api-loader';



@Injectable({
  providedIn: 'root',
})
export class VisitorsService {
  isBrowser: boolean;
  mapKey = globalConstant.GOOGLE_MAPS_API_KEY
  apiDomain = globalConstant.DOMAIN;
  siteRequestFrom = globalConstant.SITE_REQUEST_FROM;
  getUserLocationApi = globalConstant.GET_USER_LOCATION_API;
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;


  private geoCoder: any;
  private googleMapsLoaderPromise: Promise<void>;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

  }

  loadGoogleMaps(): Promise<void> {
    if (!this.isBrowser) return Promise.resolve();  // Ensure this only runs in browser
  
    // Only load the Google Maps API once
    if (!this.googleMapsLoaderPromise) {
      const loader = new Loader({
        apiKey: this.mapKey,
        libraries: ['places'],
        version: "weekly",
      });
  
      // Store the loading promise in googleMapsLoaderPromise
      this.googleMapsLoaderPromise = loader.load().then(() => {
        this.geoCoder = new google.maps.Geocoder();
      }).catch((error) => {
        console.error("Error loading Google Maps API:", error);
      });
    }
  
    // Return the existing promise to ensure only one instance loads
    return this.googleMapsLoaderPromise;
  }

  setCurrentLocationForNearby() {
    return new Promise((resolve, reject) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((position: any) => { }, (error: any) => { });
        navigator.geolocation.getCurrentPosition((position: any) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          this.zoom = 8;
          this.getAddress(this.latitude, this.longitude).then((data) => {
            resolve(data);
          }).catch((error) => {
            reject(error);
          });
        }, (error: any) => {
          reject(error);
        });
      } else {
        reject({ 'lat': '', 'long': '', 'address': '' });
      }
    });
  }


  getCurrent_location(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.isBrowser) {
        this.loadGoogleMaps().then(() => {
          this.setCurrentLocation().then((data) => {
            resolve(data);
          });
        }).catch((error) => {
          reject(error);
        });
      }
    });
  }

  getIpAddress() {
    return this.http.get('https://api.ipify.org/?format=json').pipe(catchError(this.handleError));
  }

  getGEOLocation(ip) {
    // Update your api key to get from https://ipgeolocation.io
    let url = "https://api.ipgeolocation.io/ipgeo?apiKey=9dd1ee4f3d294103adb57a64b3ac49d8&ip=" + ip;
    return this.http.get(url).pipe(catchError(this.handleError));
  }

  getUserLocation(data, headers) {
    const httpOptions = {
      headers: new HttpHeaders({
        'requestFrom': this.siteRequestFrom,
        'Content-Type': 'application/json',
        'Authorization': headers == "" ? "" : 'Bearer ' + headers
      })
    };
    return this.http.post<any>(this.apiDomain + this.getUserLocationApi, data, httpOptions).pipe(map(res => {
      return res;
    }),
      catchError(err => {
        if (err.status == 401) {
          if (this.isBrowser) {

            if (typeof localStorage !== 'undefined') {
              localStorage.removeItem('authUser')
              localStorage.removeItem('login_token')
              localStorage.removeItem('profile_img_url')
            }
            if (typeof window !== 'undefined') {
              window.location.href = '/login'
            }
          }
        }
        return err.error;
      }));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }

  setCurrentLocation(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position: any) => { }, (error: any) => { });
        navigator.geolocation.getCurrentPosition((position: any) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          this.zoom = 8;
          this.getAddress(this.latitude, this.longitude).then((data) => {
            resolve(data);
          });
        }, (error: any) => {
          resolve({ 'lat': '', 'long': '', 'address': '' });
        });
      } else {
        resolve({ 'lat': '', 'long': '', 'address': '' });
      }
    });
  }

  async getCurrent_location_nearBy(): Promise<any> {
    await this.loadGoogleMaps();  // Wait for Google Maps API to load
    return this.setCurrentLocationForNearby();
  }
  


  getAddress(latitude: number, longitude: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 12;
            this.address = results[0].formatted_address;
            const array = { 'lat': latitude, 'long': longitude, 'address': results[0] };
            resolve(array);
          } else {
            resolve({ 'lat': '', 'long': '', 'address': '' });
          }
        } else {
          resolve({ 'lat': '', 'long': '', 'address': '' });
        }
      });
    });
  }

}
